import type {
  ActivityFilters,
  AnnouncementFilters,
  DashboardFilters,
  DeliveryFilters,
  UserFilters,
  UserStatsFilters,
} from "@/api/endpoints";

export const queryKeys = {
  authConfig: ["auth", "config"] as const,
  me: ["admin", "me"] as const,
  dashboard: (filters: DashboardFilters) => ["admin", "dashboard", filters] as const,
  dashboardAll: ["admin", "dashboard"] as const,
  userStats: (id: string, filters: UserStatsFilters) =>
    ["admin", "user", id, "stats", filters] as const,
  userActivity: (id: string, filters: ActivityFilters) =>
    ["admin", "user", id, "activity", filters] as const,
  users: (filters: UserFilters) => ["admin", "users", filters] as const,
  usersAll: ["admin", "users"] as const,
  user: (id: string) => ["admin", "user", id] as const,
  deliveries: (filters: DeliveryFilters) => ["admin", "deliveries", filters] as const,
  deliveriesAll: ["admin", "deliveries"] as const,
  announcements: (filters: AnnouncementFilters) => ["admin", "announcements", filters] as const,
  announcementsAll: ["admin", "announcements"] as const,
};
